import { useState } from "react";
import logo from "../../assets/img/logo.svg";
import { leadbud, solution, pages, resources } from "./navBarData";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import SubMenu from "../SubMenu";

function DesktopHeader() {
  const [leadbudMenu, setLeadbudMenu] = useState(false);
  const [solutionMenu, setSolutionMenu] = useState(false);
  const [pagesMenu, setPagesMenu] = useState(false);
  const [resourcesMenu, setResourcesMenu] = useState(false);

  const mouseEnterLeadbud = () => {
    setLeadbudMenu(true);
  };

  const mouseLeaveLeadbud = () => {
    setLeadbudMenu(false);
  };

  const mouseEnterResources = () => {
    setResourcesMenu(true);
  };

  const mouseLeaveResources = () => {
    setResourcesMenu(false);
  };

  const mouseEnterSolution = () => {
    setSolutionMenu(true);
  };

  const mouseLeaveSolution = () => {
    setSolutionMenu(false);
  };

  const mouseEnterPages = () => {
    setPagesMenu(true);
  };

  const mouseLeavePages = () => {
    setPagesMenu(false);
  };

  return (
    <header
      style={{
        paddingTop: "12px",
        paddingBottom: "12px",
        backgroundColor: "transparent",
        position: "absolute",
        width: "100%",
        top: "0",
        zIndex: 2,
      }}
    >
      <nav
        className="container Desktopheader-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          className="brand-links-wrapper"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ display: "flex" }}>
            <div
              className="nav-brand"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Link className="nav-brand-wrapper" to={"/"}>
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            <ul className={`navbar-ul links-wrapper `}>
             
              <li
                className="nav-item"
                onMouseEnter={mouseEnterSolution}
                onMouseLeave={mouseLeaveSolution}
              >
                <Link to={"#"} style={{ color: "inherit" }}>
                  Solutions
                </Link>
                {solutionMenu ? (
                  <FaChevronUp style={{ fontSize: "12px" }} />
                ) : (
                  <FaChevronDown style={{ fontSize: "12px" }} />
                )}
                <SubMenu
                  isVisible={solutionMenu}
                  data={solution}
                  className={"teams-wrapper"}
                />
              </li>
              
              <li
                className="nav-item"
                onMouseEnter={mouseEnterSolution}
                onMouseLeave={mouseLeaveSolution}
              >
                <Link to={"#"} style={{ color: "inherit" }}>
                  Resources
                </Link>
                {solutionMenu ? (
                  <FaChevronUp style={{ fontSize: "12px" }} />
                ) : (
                  <FaChevronDown style={{ fontSize: "12px" }} />
                )}
                <SubMenu
                  isVisible={solutionMenu}
                  data={solution}
                  className={"teams-wrapper"}
                />
              </li>
              <li className="nav-item">
                <Link to={"/pricing"} style={{ color: "inherit" }}>
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          <div
            style={{ alignSelf: "flex-end" }}
            className={`header-btn-wrapper`}
          >
            <Link
              to="/"
              className="Desktopheader-btn btn btn-outline-dark me-2"
              style={{ padding: "8px 20px" }}
            >
              Book a Call
            </Link>
            <Link
              to="/users/sign-up"
              style={{ padding: "8px 20px" }}
              className="Desktopheader-btn btn btn-dark"
            >
              SignUp
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default DesktopHeader;
